<template>
  <div id="mb-game-status" :style="[setGameStatusStyle(), { '--color': color }]" @click="cancelCheck()">
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInRight"
      leave-active-class="animated bounceOutRight"
    >
      <div class="status" v-if="isCorrect == 'correct' && gameCheckSwitch">
        <!-- <img v-if="icon" class="game-status-correct" :src="correctIcon" /> -->
        <div class="text-status">
          <p>{{ trueText }}</p>
        </div>
      </div>
      <div class="status" v-if="isCorrect == 'incorrect' && gameCheckSwitch">
        <!-- <img v-if="icon" class="game-status-correct" :src="incorrectIcon" /> -->
        <div class="text-status">
          <p>{{ falseText }}</p>
        </div>
      </div>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInRight"
      leave-active-class="animated bounceOutRight"
    >
      <div
        style="position: relative; transition: 0.5s"
        :style="[gameCheckSwitch ? { height: '522px' } : { height: '306px' }]"
      >
        <div
          class="color-dot"
          :style="[
            gameCheckSwitch
              ? { opacity: 1, width: '306px', height: '306px', bottom: '34px', right: '21px' }
              : { opacity: 1, bottom: '14px', right: '2px' },
            iconHover ? { opacity: 1 } : {},
          ]"
        ></div>
        <div :style="[!iconMusic ? { opacity: 1 } : { opacity: 0 }]">
          <img
            :style="[
              gameCheckSwitch && gameCheckSwitchStyle ? gameCheckSwitchStyle : {},
              gameCheckSwitch ? { opacity: 1 } : { opacity: 1 },
              iconHover ? { opacity: 1 } : {},
            ]"
            @mouseover="iconHover = true"
            @mouseout="iconHover = false"
            draggable="false"
            v-if="icon"
            class="game-status-icon"
            :src="setIcon()"
            @click="checkGame()"
          />
        </div>
        <div :style="[iconMusic ? { opacity: 1 } : { opacity: 0 }]">
          <img
            :style="[
              gameCheckSwitch && gameCheckSwitchStyle ? gameCheckSwitchStyle : {},
              gameCheckSwitch ? { opacity: 1 } : { opacity: 1 },
              iconHover ? { opacity: 1 } : {},
            ]"
            @mouseover="iconHover = true"
            @mouseout="iconHover = false"
            draggable="false"
            v-if="icon"
            class="game-status-icon icon-music"
            :src="successGif"
            @click="checkGame()"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { Howler } from 'howler';
// import INFO from '../../config/info/tablice.js';
export default {
  props: {
    icon: {
      type: [String, Array],
      default: function () {
        return '';
      },
    },
    gif: {
      type: String,
      default: function () {
        return '';
      },
    },
    successGif: {
      type: String,
      default: function () {
        return '';
      },
    },
    successIcon: {
      type: String,
      default: function () {
        return '';
      },
    },
    gameCheckSwitchStyle: {
      type: Object,
      default: function () {
        return {};
      },
    },
    communication: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  name: 'mb-game-status',
  components: {},
  data: function () {
    return {
      iconMusic: false,
      iconSet: null,
      iconHover: false,
      number: 0,
      chceckCorrect: false,
      canIcancel: false,
      audio: null,
      trueText: '',
      falseText: '',
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  mounted() {
    if (Array.isArray(this.icon)) {
      let tmp = this.shuffle(this.icon);
      this.iconSet = tmp[0];
    } else {
      this.iconSet = this.icon;
    }
  },
  methods: {
    setGameStatusStyle() {
      let style = {};
      if (this.gameCheckSwitch) {
        style.width = '100%';
        style.height = '100%';
        style.background = 'rgba(0,0,0,0.0)';
        style.transition = 'background .5s, width 0s .0s, height 0s .0s';
      } else {
        style.width = '0';
        style.height = '0';
        style.background = 'rgba(0,0,0,0.0)';
        style.transition = 'background .5s, width 0s .5s, height 0s .5s';
      }
      if (this.isCorrect == 'correct' && this.gameCheckSwitch) {
        style.background = 'rgba(0,0,0,0.3)';
      }
      return style;
    },
    cancelCheck() {
      // this.gameState = false;
      if (this.canIcancel) this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    checkGame() {
      this.$store.dispatch('checkGame');
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    createAudio(src) {
      this.audio = new Howl({
        src: src,
        autoplay: true,
        loop: false,
        volume: 0.5,
        onend: () => {
          this.iconMusic = false;
        },
        onstop: () => {
          this.iconMusic = false;
        },
        onplay: () => {
          this.iconMusic = true;
        },
      });
    },
    init() {},
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    setIcon() {
      // if (this.isCorrect == 'correct' && this.gameCheckSwitch && this.successGif != '' &&) {
      //   return this.successGif;
      // } else
      if (this.isCorrect == 'correct' && this.gameCheckSwitch && this.successIcon != '') {
        return this.successIcon;
      } else {
        if (this.gif != '') {
          return this.gif;
        } else {
          if (Array.isArray(this.icon)) {
            return this.icon[this.randomNumber(this.icon.length - 1, 0)];
          } else {
            return this.icon;
          }
        }
      }
    },
    chceck() {
      this.chceckCorrect = !this.chceckCorrect;
    },
  },
  watch: {
    gameCheckSwitch(newValue) {
      if (newValue) {
        if (this.isCorrect == 'correct') {
          let number = 0;
          if (this.communication) number = this.randomNumber(this.communication.right.length - 1, 0);
          this.trueText = this.communication.right[number].text;
          if (this.communication.right[number].sound) {
            Howler.stop();
            this.createAudio(this.communication.right[number].sound);
          }
        } else {
          let number = 0;
          if (this.communication) number = this.randomNumber(this.communication.fault.length - 1, 0);
          this.falseText = this.communication.fault[number].text;
          if (this.communication.fault[number].sound) {
            Howler.stop();
            this.createAudio(this.communication.fault[number].sound);
          }
        }
        setTimeout(() => {
          this.canIcancel = true;
        }, 1000);
      } else {
        if (this.audio) this.audio.stop();
        this.canIcancel = false;
      }
    },
  },
  beforeDestroy() {
    if (this.audio) this.audio.stop();
  },
  computed: {
    color() {
      // return this.$store.getters.getGameColor;
      return this.$store.getters.getMainColor;
    },
    isCorrect() {
      return this.$store.getters.actualGameStatus;
    },
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    correctIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/both/gameInterface/statusCorrect.png`);
      } catch {
        console.log(
          '%cCorrectIcon MbGameStatus- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    incorrectIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/both/gameInterface/statusWrong.png`);
      } catch {
        console.log(
          '%cIncorrectIcon MbGameStatus- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cExitIcon MbGameStatus- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variable'
$break-large: 1400px
#mb-game-status
  position: absolute
  text-align: right
  bottom: 0
  right: 0
  display: flex
  align-items: flex-end
  justify-content: flex-end
  flex-direction: column
  padding: 20px
  will-change: auto
  .status
    background: var(--color)
    text-align: left
    border-radius: calc(64px/6)
    // box-shadow: 0 0 10px 5px rgba(0,0,0,0.3)
    display: flex
    align-items: center
    justify-content: center
    will-change: auto
    position: relative
    .game-status-correct
      // position: absolute
      // top: 0
      // left: 0
      margin: calc(96px/5)
      width: 96px
    .text-status
      display: flex
      flex-direction: row
      align-items: center
      justify-content: center
      // position: absolute
      // top: 0
      // right: 0
      width: 100%
      padding: 23px
      font-family: $gameFontFamily
      p
        color: white
        margin: 0
        padding: 0 10px
        font-size: 22px
        font-weight: bold
  .status:after
    content: ''
    position: absolute
    border-style: solid
    border-width: 30px 0px 0 28px
    border-color: var(--color) transparent
    display: block
    width: 0
    z-index: 1
    bottom: -30px
    right: 200px

  .game-status-icon
    transition: .5s
    height: 205px
    cursor: pointer
    position: absolute
    bottom: 0
    right: 0
    will-change: auto
  .color-dot
    background: var(--color)
    width: 128px
    height: 128px
    position: absolute
    bottom: 34px
    right: 21px
    transition: .5s
    will-change: auto
    border-radius: 50%
    box-shadow: inset 0px -1px 5px rgba(0, 0, 0, 0.4)
</style>
